import { forwardRef } from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import {
  CUSTOM_BUTTON_COLOR,
  CUSTOM_BUTTON_VARIANT,
  CustomButton,
} from 'src/components/CustomButton';

import { useStyles } from './useStyles';

export const CommonNavBarButton = forwardRef(
  ({ className, classes, selected, ...restProps }, ref) => {
    const styles = useStyles({ classes });

    return (
      <CustomButton
        className={cx(styles.root, className)}
        classes={styles}
        ref={ref}
        variant={selected ? CUSTOM_BUTTON_VARIANT.contained : CUSTOM_BUTTON_VARIANT.text}
        color={selected ? CUSTOM_BUTTON_COLOR.upsell : CUSTOM_BUTTON_COLOR.gray}
        aria-selected={selected}
        {...restProps}
      />
    );
  }
);

CommonNavBarButton.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape(),
  selected: PropTypes.bool,
};
CommonNavBarButton.defaultProps = {
  className: null,
  classes: null,
  selected: false,
};
